import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TreeModule } from 'primeng/tree';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';

import { AppSharedModule } from './../shared/appShared.module';
import {
  CommmonImageComponent,
  CommonComponent,
  CommonDocumentComponent,
  CommonTreeComponent,
  CommonViewComponent,
} from './components';
import { CommonArticleService, CommonService } from './services';
import { CommonChecklistService } from './services/common-checklist.services';
import { PreventPasteDirective } from './components/directives/prevent-paste.directive';
@NgModule({ exports: [
        CommonComponent,
        CommonTreeComponent,
        CommonViewComponent,
        CommmonImageComponent,
        CommonDocumentComponent,
    ],
    declarations: [
        CommonComponent,
        CommonTreeComponent,
        CommonViewComponent,
        CommmonImageComponent,
        CommonDocumentComponent,
        PreventPasteDirective,
    ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    RouterModule,
    TableModule,
    SharedModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
        TextareaModule,
        SelectModule,
        ToggleSwitchModule,
    ContextMenuModule,
    FileUploadModule,
    FieldsetModule,
        TabsModule,
    AppSharedModule,
    TreeModule,
    CKEditorModule
  ],
  providers: [CommonService, CommonArticleService, CommonChecklistService, provideHttpClient(withInterceptorsFromDi())]
})
export class CommonBaseModule {}
